import { select, put } from "redux-saga/effects";
import exactMath from "exact-math";

import { getStudentSchoolID, getCreditTopUpAmount } from "state/school_money/selectors";
import { setBasketItem, deleteBasketItem } from "state/school_money/actions";

function formatBasketItemID(studentID, creditType) {
  return `${studentID}:${creditType}`;
}

export function* addToBasket(action) {
  const { studentID, creditType, amount } = action.payload;
  
  const previousAmount = yield select(getCreditTopUpAmount, studentID, creditType);
  const schoolID = yield select(getStudentSchoolID, studentID);
  const basketItemID = formatBasketItemID(studentID, creditType);
  const payload = { studentID, creditType };
  const price = exactMath.add(amount, previousAmount);
  
  yield put(setBasketItem("creditTopUp", basketItemID, schoolID, studentID, basketItemID, price, 1, payload));
  
}

export function* removeFromBasket(action) {
  const { studentID, creditType } = action.payload;
  const basketItemID = formatBasketItemID(studentID, creditType);
  yield put(deleteBasketItem("creditTopUp", basketItemID));
}



// WEBPACK FOOTER //
// ./src/state/school_money/sagas/basketSaga/creditTopUp.js